import { render, staticRenderFns } from "./RouteHead.vue?vue&type=template&id=22b5faa5&lang=html&"
import script from "./RouteHead.vue?vue&type=script&lang=js&"
export * from "./RouteHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports